import {TrackType} from '~/components/sections';
import {config} from '~/locals/qianfan/index';
import '~/style/wenxin/index.less';
import BasePage from './basePage';

export default function Wenxin() {
    return (
        <TrackType.Provider value={config}>
            <BasePage />
        </TrackType.Provider>
    );
}
